import React, { Fragment } from "react";
import { Link, useLocation } from "react-router-dom";
import { Stack, Typography } from "@mui/material";
import breadcrumbConfig from "./breadcrumbConfig.json";

export const Breadcrumb = () => {
  const location = useLocation();
  const currentBreadcrumb = breadcrumbConfig.find(
    (item) => item.path === location.pathname
  );

  return (
    <Stack>
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: "1rem",
        }}
      >
        {currentBreadcrumb && currentBreadcrumb.name}
      </Typography>
      <Stack direction="row" spacing={1} sx={{ marginTop: 0 }}>
        {currentBreadcrumb &&
          currentBreadcrumb.breadcrumbTrail.map((crumb, index) => (
            <Fragment key={crumb.path}>
              <Link
                to={crumb.path}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                {crumb.name}
              </Link>
              {index < currentBreadcrumb.breadcrumbTrail.length - 1 && (
                <Typography component="span" sx={{ mx: 0.5 }}>
                  &gt;
                </Typography>
              )}
            </Fragment>
          ))}
      </Stack>
    </Stack>
  );
};
